import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useAddEditLegalEntityTypeDialogHooks } from "./AddEditLegalEntityTypeDialog.hooks";
import { LegalEntityTypeViewModel } from "../legalEntityTypes/LegalEntityType.types.ts";

export interface IAddEditLegalEntityTypeDialogProps {
    onDialogClose: () => void;
    legalEntityTypeToUpdate: LegalEntityTypeViewModel | undefined;
    onSaved: () => void;
}

function AddEditLegalEntityTypeDialog(props: IAddEditLegalEntityTypeDialogProps) {
    const { translateString } = useTranslation();
    const { isAdd, isSaving, onModelChange, onSave, saveModel, validation } = useAddEditLegalEntityTypeDialogHooks(props);

    return (
        <DotLegalDialog
            size="sm"
            inProgress={isSaving}
            header={isAdd ? translateString("createLegalEntityType") : translateString("editLegalEntityType")}
            buttonOkText={isAdd ? translateString("create") : translateString("save")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onSave}
        >
            <DotLegalTextField
                label={translateString("name")}
                value={saveModel.name}
                debounce={false}
                errorText={validation.getErrorsForDisplay("name")}
                onChange={(name) => onModelChange((model) => (model.name = name))}
            />
        </DotLegalDialog>
    );
}

export default AddEditLegalEntityTypeDialog;
